import { queryOptions } from '@tanstack/react-query';

import { queries } from '@api';
import {
  retrieveActiveUser,
  retrieveUser,
} from '@api/users/api.users.requests';

export const getUserOptions = (id: string) =>
  queryOptions({
    queryKey: queries.users.retrieve(id).queryKey,
    queryFn: () => retrieveUser(id),
  });

export const getActiveUserOptions = queryOptions({
  queryKey: queries.users.activeUser.queryKey,
  queryFn: () => retrieveActiveUser(),
  gcTime: Infinity,
  staleTime: Infinity,
  retry: false,
});
